// Meta Pixel (browser). Pixel/Dataset ID is public and safe in the browser bundle.
export function initMetaPixel(pixelId) {
  if (!pixelId || window.fbq) return;
  const n = (window.fbq = function (...args) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  const first = document.getElementsByTagName("script")[0];
  first.parentNode.insertBefore(s, first);
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

// Fire the standard Lead event; eventID must match the server event_id (dedup).
export function trackLead(eventId) {
  if (window.fbq) window.fbq("track", "Lead", {}, { eventID: eventId });
}
